export const GeolocationWarningModal = () => import('../../../../components/GeolocationWarningModal.vue' /* webpackChunkName: "components/geolocation-warning-modal" */).then(c => wrapFunctional(c.default || c))
export const MicListener = () => import('../../../../components/MicListener.vue' /* webpackChunkName: "components/mic-listener" */).then(c => wrapFunctional(c.default || c))
export const WebPlayerComponent = () => import('../../../../components/WebPlayerComponent.vue' /* webpackChunkName: "components/web-player-component" */).then(c => wrapFunctional(c.default || c))
export const WebPlayerControls = () => import('../../../../components/WebPlayerControls.vue' /* webpackChunkName: "components/web-player-controls" */).then(c => wrapFunctional(c.default || c))
export const WebPlayerDisplay = () => import('../../../../components/WebPlayerDisplay.vue' /* webpackChunkName: "components/web-player-display" */).then(c => wrapFunctional(c.default || c))
export const WebPlayerInfoModal = () => import('../../../../components/WebPlayerInfoModal.vue' /* webpackChunkName: "components/web-player-info-modal" */).then(c => wrapFunctional(c.default || c))
export const WebPlayerInteractionModal = () => import('../../../../components/WebPlayerInteractionModal.vue' /* webpackChunkName: "components/web-player-interaction-modal" */).then(c => wrapFunctional(c.default || c))
export const WebPlayerMap = () => import('../../../../components/WebPlayerMap.vue' /* webpackChunkName: "components/web-player-map" */).then(c => wrapFunctional(c.default || c))
export const WebPlayerProgressBar = () => import('../../../../components/WebPlayerProgressBar.vue' /* webpackChunkName: "components/web-player-progress-bar" */).then(c => wrapFunctional(c.default || c))
export const WebPlayerVideo = () => import('../../../../components/WebPlayerVideo.vue' /* webpackChunkName: "components/web-player-video" */).then(c => wrapFunctional(c.default || c))
export const WebPlayerYoutube = () => import('../../../../components/WebPlayerYoutube.vue' /* webpackChunkName: "components/web-player-youtube" */).then(c => wrapFunctional(c.default || c))
export const StylizedModal = () => import('../../../../components/common/StylizedModal.vue' /* webpackChunkName: "components/stylized-modal" */).then(c => wrapFunctional(c.default || c))

// nuxt/nuxt.js#8607
function wrapFunctional(options) {
  if (!options || !options.functional) {
    return options
  }

  const propKeys = Array.isArray(options.props) ? options.props : Object.keys(options.props || {})

  return {
    render(h) {
      const attrs = {}
      const props = {}

      for (const key in this.$attrs) {
        if (propKeys.includes(key)) {
          props[key] = this.$attrs[key]
        } else {
          attrs[key] = this.$attrs[key]
        }
      }

      return h(options, {
        on: this.$listeners,
        attrs,
        props,
        scopedSlots: this.$scopedSlots,
      }, this.$slots.default)
    }
  }
}
